import React, { useState, useEffect, useRef } from 'react';
import './documentInfo.css';
import { Modal } from '../shared/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const DocumentInfo = ({ title, content, contentHtml, hasTallContent }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [showMoreIsVisible, setShowMoreIsVisible] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const checkForScrollbar = () => {
      if (contentRef.current) {
        const hasScrollbar =
          contentRef.current.scrollHeight > contentRef.current.clientHeight;
        setShowMoreIsVisible(hasScrollbar);
      }
    };

    checkForScrollbar();
    window.addEventListener('resize', checkForScrollbar);

    return () => {
      window.removeEventListener('resize', checkForScrollbar);
    };
  }, []);

  return (
    <React.Fragment>
      <div className={`document-info`}>
        <div className={`document-info-title`}>
          <h4>{title}</h4>
          {showMoreIsVisible && (
            <div
              className="document-info-title-pop-out-link"
              onClick={() => setModalOpen(true)}
            >
              <span>show all</span>
              <FontAwesomeIcon size="sm" icon={faExternalLinkAlt} />
            </div>
          )}
        </div>
        <div
          ref={contentRef}
          className={`document-info-content ${hasTallContent ? 'tall' : ''}`}
        >
          {contentHtml ? (
            <div dangerouslySetInnerHTML={{ __html: contentHtml }} />
          ) : (
            content
          )}
        </div>
      </div>
      <Modal show={isModalOpen} onClose={() => setModalOpen(false)}>
        <div className="document-info-modal">
          <div className="document-info-modal-title">{title}</div>
          <div className="document-info-modal-content">{content}</div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default DocumentInfo;
